import { httpRequest } from "../../http";

export class CmdSaveTagHero {
  async run(hero: File, organizationId: number, tagId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/store/tags/${tagId}/hero/`;
    const formData = new FormData();
    formData.append("file", hero);
    try {
      const response = await httpRequest<any>(url, { method: "POST", body: formData });
      if (response) {
        console.log(response);
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
}
